export { default as Typography } from './Typography';

export type Align = import('./Typography').Align;
export type Color = import('./Typography').Color;
